import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CaretDownOutlined, EditOutlined, EnvironmentOutlined, HistoryOutlined, MedicineBoxOutlined, PlusCircleOutlined, PrinterOutlined, TransactionOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { Appointments, Patient as PatientResource, ReservationPackage, Transaction } from 'constants/resources';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { useNavigate, useParams } from 'react-router-dom';
import services from 'services';
import '../style.css';
var initialsFromName = function (name) {
    if (!name)
        return '—';
    var parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '—';
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return "".concat(parts[0][0]).concat(parts[parts.length - 1][0]).toUpperCase();
};
var Header = function (props) {
    var _a, _b;
    var t = props.translate, patient = props.patient;
    var navigate = useNavigate();
    var id = useParams().id;
    var permissionService = services.permissionService;
    if (!patient)
        return null;
    var canEdit = permissionService.hasPermissionToEdit(PatientResource);
    var canAddAppointment = permissionService.hasPermissionToAdd(Appointments);
    var canAddPackage = permissionService.hasPermissionToAdd(ReservationPackage);
    var canAddTransaction = permissionService.hasPermissionToAdd(Transaction);
    var canOpenLog = permissionService.hasPatientLogPermission();
    var onEdit = function () { return navigate("/patients/".concat(id, "/update")); };
    var onAddAppointment = function () { return props.setShowAppointmentDrawer(true); };
    var onAddPackage = function () { return props.setShowReservationPackagesDrawer(true); };
    var onAddTransaction = function () { return props.setShowTransactionDrawer(true); };
    var onOpenPatientLog = function () { return props.setShowPatientLogDrawer(true); };
    var areaName = ((_b = (_a = patient.getPatientArea()) === null || _a === void 0 ? void 0 : _a.getName) === null || _b === void 0 ? void 0 : _b.call(_a)) || '';
    var genderAge = [patient.getTranslatedGender(), patient.getAge()].filter(Boolean).join(', ') ||
        '';
    var actionItems = [];
    if (canAddAppointment) {
        actionItems.push({
            key: 'appointment',
            icon: _jsx(PlusCircleOutlined, {}),
            label: t('header.addAppointment'),
            onClick: onAddAppointment
        });
    }
    if (canAddPackage) {
        actionItems.push({
            key: 'package',
            icon: _jsx(MedicineBoxOutlined, {}),
            label: t('header.addReservation'),
            onClick: onAddPackage
        });
    }
    if (canAddTransaction) {
        actionItems.push({
            key: 'transaction',
            icon: _jsx(TransactionOutlined, {}),
            label: t('header.addTransaction'),
            onClick: onAddTransaction
        });
    }
    actionItems.push({
        key: 'print',
        icon: _jsx(PrinterOutlined, {}),
        label: t('header.print'),
        onClick: function () { var _a; return (_a = props.onPrint) === null || _a === void 0 ? void 0 : _a.call(props); }
    });
    if (canOpenLog) {
        if (actionItems.length) {
            actionItems.push({ type: 'divider' });
        }
        actionItems.push({
            key: 'log',
            icon: _jsx(HistoryOutlined, {}),
            label: t('header.patientLog'),
            onClick: onOpenPatientLog,
            danger: true
        });
    }
    return (_jsxs("header", { className: "patient-profile__hero", "data-onboarding": "patient-header", children: [_jsxs("div", { className: "patient-profile__hero-left", children: [_jsxs("div", { className: "patient-profile__avatar-wrap", children: [_jsx("div", { className: "patient-profile__avatar", "aria-hidden": true, children: initialsFromName(patient.getName()) }), _jsx("span", { className: "patient-profile__avatar-dot", title: t('header.active') })] }), _jsxs("div", { className: "patient-profile__hero-text", children: [_jsxs("div", { className: "patient-profile__title-row", children: [_jsx("h1", { className: "patient-profile__name", children: patient.getName() }), _jsxs("span", { className: "patient-profile__active", children: [_jsx("span", { className: "patient-profile__active-dot", "aria-hidden": true }), t('header.active')] })] }), _jsxs("div", { className: "patient-profile__meta", children: [patient.getCode() && (_jsx("span", { className: "patient-profile__meta-mono", children: "MRN: ".concat(patient.getCode()) })), genderAge && (_jsxs(_Fragment, { children: [patient.getCode() && (_jsx("span", { className: "patient-profile__meta-sep", "aria-hidden": true, children: "\u2022" })), _jsx("span", { children: genderAge })] })), areaName && (_jsxs(_Fragment, { children: [(patient.getCode() || genderAge) && (_jsx("span", { className: "patient-profile__meta-sep", "aria-hidden": true, children: "\u2022" })), _jsxs("span", { className: "patient-profile__meta-place", children: [_jsx(EnvironmentOutlined, {}), areaName] })] }))] })] })] }), _jsxs("div", { className: "patient-profile__hero-actions no-print", children: [canEdit && (_jsxs("button", { type: "button", className: "patient-profile__btn patient-profile__btn--secondary", onClick: onEdit, children: [_jsx(EditOutlined, {}), _jsx("span", { children: t('header.edit') })] })), actionItems.length > 0 && (_jsx(Dropdown, { menu: { items: actionItems }, placement: "bottomRight", trigger: ['click'], children: _jsxs("button", { type: "button", className: "patient-profile__btn patient-profile__btn--primary", "data-onboarding": "patient-actions", children: [_jsx("span", { children: t('common:buttons.actions') }), _jsx(CaretDownOutlined, {})] }) }))] })] }));
};
export default localeTranslator(Header, 'showPatient');
